import { ToolsClass } from '../classes/tools.class'
// import { CookieClass } from '../classes/cookie.class'

const storageKey = 'bmPrivacy'
let _activeAgreements = []

export const getSettingsFromStorage = () => {
  let settings
  try {
    settings = JSON.parse(atob(localStorage.getItem(storageKey)))
  } catch (e) {}
  if (!settings) {
    const now = new Date()
    // let id = CookieClass.getCookieValue('_bmp_id') || ToolsClass.generateUUID()
    let id = ToolsClass.generateUUID()
    settings = {
      createdAt: +now,
      uuid: id,
      version: window.bluemedia.privacy.version,
      recognizedVendors: [],
      vendorAgreements: [],
      purposeAgreements: []
    }
    // CookieClass.setCookie('_bmp_id', id, { expiryDate: new Date(now.getFullYear() + 1, now.getMonth(), now.getDate()) })
  }
  _activeAgreements = [...settings.vendorAgreements, ...settings.purposeAgreements]
  return settings
}

export const setSettingsInStorage = (settings, bmPrivacyConfig, language) => {
  return new Promise((resolve, reject) => {
    const currentAgreements = [...settings.vendorAgreements, ...settings.purposeAgreements]
    if (settings.updatedAt && JSON.stringify(currentAgreements) === JSON.stringify(_activeAgreements)) {
      return resolve(false)
    }
    settings.language = language
    const img = new Image()
    img.src = 'https://privacy' + (bmPrivacyConfig && bmPrivacyConfig.env && bmPrivacyConfig.env !== 'production' ? '-stg' : '') + '.bm.pl/update-statement?token=' + btoa(JSON.stringify(settings))
    img.onload = function () {
      settings.updatedAt = +new Date()
      localStorage.setItem(storageKey, btoa(JSON.stringify(settings)))
      if (_activeAgreements.every(vendorId => currentAgreements.includes(vendorId))) {
        _activeAgreements = [...currentAgreements]
        return resolve(true)
      }
      window.location.reload()
    }
    img.onerror = (e) => reject(e)
  })
}

export const clearStorage = () => {
  localStorage.removeItem(storageKey)
}
